import { gql } from '@apollo/client';
import { BasicRoleResponse, RolesPaginationData } from './types';

export interface CustomRoleResponse extends BasicRoleResponse {
  organisation: { code: string; name: string };
}

export interface AllCustomRoleResponse {
  allCustomRoles: RolesPaginationData<CustomRoleResponse>;
}

export const GET_CUSTOM_ROLES_N_PERMISSIONS = gql`
  query allCustomRoles(
    $pageNumber: Int = 0
    $pageSize: Int = 10
    $search: String = ""
  ) {
    allCustomRoles(
      pageNumber: $pageNumber
      pageSize: $pageSize
      search: $search
    ) {
      totalCount
      roles {
        id
        name
        description
        permissions
        organisation {
          code
          name
        }
      }
    }
  }
`;
